"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminRoutes = exports.TenantDeactivatedEventV1 = exports.TenantUpdatedEventV1 = exports.TenantCreatedEventV1 = exports.TenantEventInfo = exports.UsersLookupReplyV1 = exports.UserLookupItemV1 = exports.UsersLookupQueryV1 = exports.UsersListReplyV1 = exports.UsersListQueryV1 = exports.UserUpdateCommandV1 = exports.UserCreateCommandV1 = exports.UserCreateReplyV1 = exports.TenantCreateReplyV1 = exports.TenantsListReplyV1 = exports.TenantItem = exports.TenantsListQueryV1 = exports.TenantDeactivateCommandV1 = exports.TenantUpdateCommandV1 = exports.ACTENSO_PANEL_KEY_PATTERN = exports.TenantCreateCommandV1 = exports.TenantCustomDomain = exports.CustomDomainHostInput = exports.ConnectionLimit = exports.TenantId = exports.HexColor = exports.UserStatus = void 0;
const zod_1 = require("zod");
const message_1 = require("./message");
const user_presence_1 = require("./user-presence");
const subject_contract_1 = require("./subject-contract");
const ack_reply_1 = require("./ack-reply");
/**
 * @deprecated Используй `SipStatus` (derived) + `businessStatus` (свободная
 * строка) из `user-presence.ts`. Старый enum смешивал derived и explicit и
 * остаётся только для обратной совместимости поля `core.users.status` до его
 * удаления в следующем релизе. Новые контракты — не использовать.
 */
exports.UserStatus = zod_1.z.enum(['online', 'offline', 'break', 'leave']);
// ── Tenant commands ──
/** Цвет хедера UI тенанта в формате `#RRGGBB`. */
exports.HexColor = zod_1.z.string().regex(/^#[0-9a-fA-F]{6}$/, 'ожидается #RRGGBB');
/**
 * ID тенанта — он же SIP-домен его точек доступа и realm digest-авторизации.
 *
 * Граница стоит здесь, а не по месту использования, потому что из id
 * server-derived строятся сразу три вещи: SIP-домен sipuser'а
 * (`resolveOwnedSipDomain`), `HA1 = MD5(username:domain:password)` и имя
 * NATS-аккаунта `SERVER_<id>` в tenants.conf (рендерится без кавычек).
 *
 * Charset — ABNF `toplabel` из RFC 3261 §25.1: ALPHA в начале, alphanum в
 * конце, внутри alphanum и `-`. Подчёркивания в нём нет, и тенант
 * `tomsk_cardio` это показал: Kamailio, Asterisk и baresip парсят URI
 * либерально и молчали, а WebRTC-панель не поднималась вообще — SIP.js отбивал
 * `sip:100@tomsk_cardio is not a valid uri`. Подменить домен на стороне
 * клиента нельзя: realm обязан совпадать с tenantId, иначе не сойдётся HA1.
 *
 * ⚠ Граница — только на СОЗДАНИИ. Тенанты с `_`, заведённые раньше, работают
 * дальше: переименование tenantId это смена NATS-аккаунта, RLS-ключа и realm
 * всех SIP-точек — осознанная операция, а не валидация envelope.
 */
exports.TenantId = zod_1.z
    .string()
    .min(1)
    .max(64)
    .regex(/^[A-Za-z](?:[A-Za-z0-9-]*[A-Za-z0-9])?$/, 'латиница и цифры, дефис внутри: id тенанта — это его SIP-домен (RFC 3261), подчёркивание и точка в нём запрещены');
/**
 * Лимит одновременных NATS-подключений аккаунта тенанта (эпик STRATACC, O4): целое > 0.
 * В командах `null` снимает лимит, опущенное поле — не менять. Без `.default()` (конвенция проекта).
 */
exports.ConnectionLimit = zod_1.z.number().int().positive().max(1_000_000);
/**
 * Свой веб-домен тенанта на входе команды (эпик CUSTDOM). Схема намеренно мягкая: шина валидирует
 * ДО handler'а, а приведение к хосту (регистр, punycode, завершающая точка) и отказ с причиной
 * делает `normalizeCustomDomainHost` в handler'е — иначе `Callc.Ru.` отбивался бы раньше, чем его
 * нормализуют. ⚠ Веб-домен, НЕ SIP: realm тенанта всегда = его id.
 */
exports.CustomDomainHostInput = zod_1.z.string().min(1).max(253);
/** Свой веб-домен тенанта в снимке. `verifiedAt: null` — домен заведён, но в подсказке на входе не участвует. */
exports.TenantCustomDomain = zod_1.z.object({
    host: zod_1.z.string(),
    verifiedAt: zod_1.z.string().datetime().nullable(),
});
exports.TenantCreateCommandV1 = message_1.CommandMessage.extend({
    type: zod_1.z.literal('TenantCreateCommand'),
    version: zod_1.z.literal(1),
    /** ID нового тенанта (НЕ путать с envelope tenantId — это tenant отправителя) */
    newTenantId: exports.TenantId,
    name: zod_1.z.string().min(1).max(255),
    adminUsername: zod_1.z.string().min(1).max(64),
    adminPassword: zod_1.z.string().min(1),
    /** Явный цвет хедера UI (#RRGGBB). Опущен → авто-цвет из имени на стороне UI. */
    color: exports.HexColor.optional(),
});
/**
 * Алфавит ключа панели Actenso (ACTPANEL O2): ключ — `ak_live_` + JWT, только `[A-Za-z0-9._-]`.
 * Узкий алфавит — защита маскирования в логе: в ключе нет символов, которые Fetch нормализует
 * в заголовке (пробелы) или JSON экранирует в эхе ответа (`"`, `\`), поэтому ключ в любом эхе
 * совпадает с тем, что ищет маскировщик. Один образец на контракт записи, сервис обмена и форму.
 */
exports.ACTENSO_PANEL_KEY_PATTERN = /^[A-Za-z0-9._-]+$/;
exports.TenantUpdateCommandV1 = message_1.CommandMessage.extend({
    type: zod_1.z.literal('TenantUpdateCommand'),
    version: zod_1.z.literal(1),
    targetTenantId: zod_1.z.string().min(1),
    name: zod_1.z.string().min(1).max(255).optional(),
    /** Явный цвет хедера UI (#RRGGBB). `null` → сбросить в авто; опущен → не менять. */
    color: exports.HexColor.nullable().optional(),
    /**
     * Лимит браузерных подключений аккаунта `PUBLIC_<t>`. `null` → снять лимит; опущен → не менять.
     * Правит только system-admin (`cmd.admin.*`); тенанту `system` не задаётся.
     */
    maxBrowserConnections: exports.ConnectionLimit.nullable().optional(),
    /** То же для процессов стратегий (аккаунт `STRATEGY_<t>`). */
    maxStrategyConnections: exports.ConnectionLimit.nullable().optional(),
    /**
     * Свои веб-домены тенанта — замена набора целиком: `[]` убирает все, опущено — не менять.
     * Правит только system-admin; занятый другим тенантом хост → `domain_taken:<host>`.
     */
    customDomains: zod_1.z.array(exports.CustomDomainHostInput).max(20).optional(),
    /**
     * API-ключ панели Actenso организации (ACTPANEL O2). Только на запись: в ответах — лишь
     * `hasActensoPanelKey`, в событие не попадает. `null` → снять; опущен → не менять.
     * Правит только system-admin. Формат — `ACTENSO_PANEL_KEY_PATTERN` (края обрезаются).
     */
    actensoPanelKey: zod_1.z
        .string()
        .trim()
        .min(1)
        .regex(exports.ACTENSO_PANEL_KEY_PATTERN, 'ключ Actenso: латиница, цифры, «.», «_», «-»')
        .nullable()
        .optional(),
});
exports.TenantDeactivateCommandV1 = message_1.CommandMessage.extend({
    type: zod_1.z.literal('TenantDeactivateCommand'),
    version: zod_1.z.literal(1),
    targetTenantId: zod_1.z.string().min(1),
});
// ── Tenant queries ──
exports.TenantsListQueryV1 = message_1.QueryMessage.extend({
    type: zod_1.z.literal('TenantsListQuery'),
    version: zod_1.z.literal(1),
    limit: zod_1.z.number().int().positive().max(1000).optional(),
    offset: zod_1.z.number().int().nonnegative().optional(),
});
exports.TenantItem = zod_1.z.object({
    id: zod_1.z.string(),
    name: zod_1.z.string(),
    isActive: zod_1.z.boolean(),
    createdAt: zod_1.z.string().datetime(),
    /** Явный цвет хедера UI (#RRGGBB). `null` → авто-цвет из имени. */
    color: zod_1.z.string().nullable(),
    /** Лимит браузерных подключений (`PUBLIC_<t>`); `null` — без лимита. */
    maxBrowserConnections: zod_1.z.number().int().positive().nullable().optional(),
    /** Лимит подключений процессов стратегий (`STRATEGY_<t>`); `null` — без лимита. */
    maxStrategyConnections: zod_1.z.number().int().positive().nullable().optional(),
    /** Свои веб-домены (CUSTDOM). Опционально на чтении: ответ узла старше эпика поля не несёт. */
    customDomains: zod_1.z.array(exports.TenantCustomDomain).optional(),
    /**
     * Задан ли ключ панели Actenso (ACTPANEL O2) — сам ключ наружу не отдаётся. Опционально на
     * чтении: ответ узла старше эпика поля не несёт.
     */
    hasActensoPanelKey: zod_1.z.boolean().optional(),
});
exports.TenantsListReplyV1 = zod_1.z.object({
    type: zod_1.z.literal('TenantsListReply'),
    version: zod_1.z.literal(1),
    correlationId: zod_1.z.string().uuid(),
    tenantId: zod_1.z.string(),
    timestamp: zod_1.z.string().datetime(),
    items: zod_1.z.array(exports.TenantItem),
    total: zod_1.z.number().int().nonnegative(),
});
/**
 * Reply на `cmd.admin.tenant.create`. Успех несёт `tenantId` (id созданного
 * тенанта, lowercased). Ошибка — message в `error`.
 */
exports.TenantCreateReplyV1 = zod_1.z.discriminatedUnion('isOk', [
    zod_1.z.object({ isOk: zod_1.z.literal(true), tenantId: zod_1.z.string() }),
    zod_1.z.object({ isOk: zod_1.z.literal(false), error: zod_1.z.string() }),
]);
/**
 * Reply на `cmd.admin.user.create`. Успех несёт `userId` (UUID нового пользователя).
 */
exports.UserCreateReplyV1 = zod_1.z.discriminatedUnion('isOk', [
    zod_1.z.object({ isOk: zod_1.z.literal(true), userId: zod_1.z.string() }),
    zod_1.z.object({ isOk: zod_1.z.literal(false), error: zod_1.z.string() }),
]);
// ── User commands ──
exports.UserCreateCommandV1 = message_1.CommandMessage.extend({
    type: zod_1.z.literal('UserCreateCommand'),
    version: zod_1.z.literal(1),
    targetTenantId: zod_1.z.string().min(1),
    username: zod_1.z.string().min(1).max(64),
    password: zod_1.z.string().min(1),
    roles: zod_1.z.array(zod_1.z.string()),
    sipUserId: zod_1.z.number().int().positive().optional(),
    sipSbcUnitId: zod_1.z.string().min(1).max(64).regex(/^[a-z0-9][a-z0-9_-]*$/).optional(),
    /** Человекочитаемое имя. Не передан → NULL (UI покажет username). */
    displayName: zod_1.z.string().min(1).max(128).optional(),
    /** UI-флаги панели (не права). Не переданы → DEFAULT БД (`true`). */
    panelEnabled: user_presence_1.UserSnapshot.shape.panelEnabled.optional(),
    panelChatEnabled: user_presence_1.UserSnapshot.shape.panelChatEnabled.optional(),
    panelSoftphoneEnabled: user_presence_1.UserSnapshot.shape.panelSoftphoneEnabled.optional(),
}).superRefine((value, ctx) => {
    if ((value.sipUserId === undefined) !== (value.sipSbcUnitId === undefined)) {
        ctx.addIssue({ code: zod_1.z.ZodIssueCode.custom, path: ['sipSbcUnitId'], message: 'sipUserId и sipSbcUnitId задаются парой' });
    }
});
exports.UserUpdateCommandV1 = message_1.CommandMessage.extend({
    type: zod_1.z.literal('UserUpdateCommand'),
    version: zod_1.z.literal(1),
    userId: zod_1.z.string().min(1),
    targetTenantId: zod_1.z.string().min(1),
    username: zod_1.z.string().min(1).max(64).optional(),
    /**
     * Человекочитаемое имя: строка — задать, `null` (или пустая строка) — очистить,
     * поле не передано — не менять.
     */
    displayName: zod_1.z.string().max(128).nullable().optional(),
    roles: zod_1.z.array(zod_1.z.string()).optional(),
    isActive: zod_1.z.boolean().optional(),
    newPassword: zod_1.z.string().min(1).optional(),
    sipUserId: zod_1.z.number().int().positive().nullable().optional(),
    sipSbcUnitId: zod_1.z.string().min(1).max(64).regex(/^[a-z0-9][a-z0-9_-]*$/).nullable().optional(),
    status: exports.UserStatus.optional(),
    /** UI-флаг панели (не право): `undefined` — не менять. */
    panelEnabled: user_presence_1.UserSnapshot.shape.panelEnabled.optional(),
    /** UI-флаг чата в панели: `undefined` — не менять. Независим от `panelEnabled`. */
    panelChatEnabled: user_presence_1.UserSnapshot.shape.panelChatEnabled.optional(),
    /** UI-флаг софтфона в панели: `undefined` — не менять. Независим от `panelEnabled`. */
    panelSoftphoneEnabled: user_presence_1.UserSnapshot.shape.panelSoftphoneEnabled.optional(),
}).superRefine((value, ctx) => {
    const hasId = value.sipUserId !== undefined;
    const hasUnit = value.sipSbcUnitId !== undefined;
    if (hasId !== hasUnit || (hasId && ((value.sipUserId === null) !== (value.sipSbcUnitId === null)))) {
        ctx.addIssue({ code: zod_1.z.ZodIssueCode.custom, path: ['sipSbcUnitId'], message: 'sipUserId и sipSbcUnitId обновляются парой' });
    }
});
exports.UsersListQueryV1 = message_1.QueryMessage.extend({
    type: zod_1.z.literal('UsersListQuery'),
    version: zod_1.z.literal(1),
    filterTenantId: zod_1.z.string().min(1).optional(),
    limit: zod_1.z.number().int().positive().max(1000).optional(),
    offset: zod_1.z.number().int().nonnegative().optional(),
});
/**
 * Reply на q.admin.users.list. Items — `UserSnapshot` (включает sipStatus +
 * businessStatus + *_changed_at). Используется DataSource'ом стратегий.
 */
exports.UsersListReplyV1 = zod_1.z.object({
    type: zod_1.z.literal('UsersListReply'),
    version: zod_1.z.literal(1),
    correlationId: zod_1.z.string().uuid(),
    tenantId: zod_1.z.string(),
    timestamp: zod_1.z.string().datetime(),
    items: zod_1.z.array(user_presence_1.UserSnapshot),
    total: zod_1.z.number().int().nonnegative(),
});
/**
 * `q.admin.users.lookup` (эпик ACCESS): справочник сотрудников для выпадашек форм
 * (выбор операторов очереди и т.п.). Доступен каждому вошедшему человеку тенанта, поэтому
 * только идентификация — id, логин, имя, активность; роли, SIP-привязка и статусы
 * присутствия сюда НЕ входят. Всегда в тенанте отправителя (`filterTenantId` нет).
 * `role` — серверный фильтр («только операторы»): роли в ответ не уходят.
 */
exports.UsersLookupQueryV1 = message_1.QueryMessage.extend({
    type: zod_1.z.literal('UsersLookupQuery'),
    version: zod_1.z.literal(1),
    text: zod_1.z.string().max(128).optional(),
    role: zod_1.z.string().min(1).max(64).optional(),
    limit: zod_1.z.number().int().positive().max(1000).optional(),
});
exports.UserLookupItemV1 = zod_1.z.object({
    id: zod_1.z.string(),
    /** Логин (ключ входа). Для показа — `displayName ?? username`. */
    username: zod_1.z.string(),
    displayName: zod_1.z.string().nullable(),
    isActive: zod_1.z.boolean(),
});
exports.UsersLookupReplyV1 = zod_1.z.object({
    type: zod_1.z.literal('UsersLookupReply'),
    version: zod_1.z.literal(1),
    correlationId: zod_1.z.string().uuid(),
    tenantId: zod_1.z.string(),
    timestamp: zod_1.z.string().datetime(),
    items: zod_1.z.array(exports.UserLookupItemV1),
    total: zod_1.z.number().int().nonnegative(),
});
// ── Tenant events (FABOLA-ARCH-FIX 2.6) ──
//
// Event-driven синхронизация тенантов между инстансами (corenode-2/-3,
// standalone mixer) вместо 5-минутного polling'а: создание/деактивация
// подхватываются подписчиками за секунды. Публикуются в TENANT_system bus.
// Также инвалидируют кэш auth callout (negative-кэш «тенант не найден» после
// create, активность после deactivate).
/** Снимок тенанта в событии (бизнес-поля, без nkey_seed и ключа панели Actenso). */
exports.TenantEventInfo = zod_1.z.object({
    id: zod_1.z.string(),
    name: zod_1.z.string(),
    isActive: zod_1.z.boolean(),
    color: exports.HexColor.nullable().optional(),
    maxBrowserConnections: zod_1.z.number().int().positive().nullable().optional(),
    maxStrategyConnections: zod_1.z.number().int().positive().nullable().optional(),
    customDomains: zod_1.z.array(exports.TenantCustomDomain).optional(),
});
exports.TenantCreatedEventV1 = message_1.EventMessage.extend({
    type: zod_1.z.literal('TenantCreatedEvent'),
    version: zod_1.z.literal(1),
    tenant: exports.TenantEventInfo,
});
exports.TenantUpdatedEventV1 = message_1.EventMessage.extend({
    type: zod_1.z.literal('TenantUpdatedEvent'),
    version: zod_1.z.literal(1),
    tenant: exports.TenantEventInfo,
});
exports.TenantDeactivatedEventV1 = message_1.EventMessage.extend({
    type: zod_1.z.literal('TenantDeactivatedEvent'),
    version: zod_1.z.literal(1),
    /** ID деактивированного тенанта (envelope.tenantId = system, не он). */
    targetTenantId: zod_1.z.string(),
});
// ── Routes (subject + input schema + reply schema атомом) ──
/**
 * Routes-таблица admin-домена. Subject + input + reply атомом — изменение в
 * schema вызывает каскад компиляторных ошибок у всех потребителей.
 */
exports.AdminRoutes = {
    tenantCreate: (0, subject_contract_1.defineCommand)('cmd.admin.tenant.create', exports.TenantCreateCommandV1, exports.TenantCreateReplyV1),
    tenantUpdate: (0, subject_contract_1.defineCommand)('cmd.admin.tenant.update', exports.TenantUpdateCommandV1, ack_reply_1.AckReplyV1),
    tenantDeactivate: (0, subject_contract_1.defineCommand)('cmd.admin.tenant.deactivate', exports.TenantDeactivateCommandV1, ack_reply_1.AckReplyV1),
    tenantsList: (0, subject_contract_1.defineQuery)('q.admin.tenants.list', exports.TenantsListQueryV1, exports.TenantsListReplyV1),
    userCreate: (0, subject_contract_1.defineCommand)('cmd.admin.user.create', exports.UserCreateCommandV1, exports.UserCreateReplyV1),
    userUpdate: (0, subject_contract_1.defineCommand)('cmd.admin.user.update', exports.UserUpdateCommandV1, ack_reply_1.AckReplyV1),
    usersList: (0, subject_contract_1.defineQuery)('q.admin.users.list', exports.UsersListQueryV1, exports.UsersListReplyV1),
    usersLookup: (0, subject_contract_1.defineQuery)('q.admin.users.lookup', exports.UsersLookupQueryV1, exports.UsersLookupReplyV1),
    tenantCreated: (0, subject_contract_1.defineEvent)('evt.admin.tenant.created', exports.TenantCreatedEventV1),
    tenantUpdated: (0, subject_contract_1.defineEvent)('evt.admin.tenant.updated', exports.TenantUpdatedEventV1),
    tenantDeactivated: (0, subject_contract_1.defineEvent)('evt.admin.tenant.deactivated', exports.TenantDeactivatedEventV1),
};
//# sourceMappingURL=admin.js.map